/* eslint-disable import/prefer-default-export */

export { default as ShelfMessage } from './ShelfMessage';



// WEBPACK FOOTER //
// ./app/components/shared/Messages/index.js